export const faqData = {
  header: {
    badge: {
      text: "Frequently Asked Questions",
      icon: "HelpOutlineIcon"
    },
    title: "Got Questions? We Have Answers!",
    description: "Find answers to the most common questions about our home inspection services. Can't find what you're looking for? Contact us directly!"
  },
  faqs: [
    { 
      question: 'What is Home Inspection?', 
      answer: 'Visual examination of each component of home with the help of advance tools and modern technology by professional home inspectors.',
      category: 'General'
    },
    { 
      question: 'What are the benefits of home Inspection?', 
      answer: 'Home Inspection helps to identify defects in your new home which you can get rectify easily from developer or builder before taking possession or moving into it. Such defects would become expensive if not uncovered on time and then homebuyer has to pay from pocket to rectify these defects in future.',
      category: 'Benefits'
    },
    { 
      question: 'How much time required for home Inspection?', 
      answer: 'The size and condition of the home is the main factor hence on an average 3 to 4 hours are sufficient to carried out complete home inspection.',
      category: 'Process'
    },
    { 
      question: 'What does a home inspection covers?', 
      answer: 'Home inspection covers Leakage /Dampness identification, Electrical inspection, Plumbing inspection, Door and window inspection, Walls and ceiling inspection, Floor tiles and dado tiles inspection, Countertops and cabinet inspections, Exhaust and ventilation inspection, Inner side shaft and duct inspection, RERA Carpet area verification and many more.',
      category: 'Coverage'
    },
    { 
      question: 'Why is the need of home inspection for new home?', 
      answer: 'Home is the most significant investment for any homebuyer. Home inspection will provide technical knowledge of the property and reveals significant defects in the property. On that basis home buyer can get rectified all the defects from developer before taking possession of new home and avoid unwanted surprises after moving into it.',
      category: 'Importance'
    },
    { 
      question: 'Is Home buyer presence necessary?', 
      answer: 'Homebuyer presence is not mandatory during home inspection. But if homebuyer wants to be there during home inspection then it will be valuable experience for them as they can see how the inspection team is carrying out detailed inspection with the help of various tools and can ask any doubt to team to get knowledge about the property condition.',
      category: 'Process'
    },
    { 
      question: 'What is the cost of Home Inspection services?', 
      answer: 'As per market survey complete home inspection service starts from 7000/- (for 1 BHK) but SnagEasy provides this from 4000/- (for 1 BHK).',
      category: 'Pricing'
    },
    { 
      question: 'Can homebuyer do the home inspection itself?', 
      answer: 'It is not recommended. Technical aspects, knowledge and experience is necessary for the ideal home inspection. Many hidden defects as well as civil, electric and plumbing aspects not possible to check thoroughly without help of technically expert team and absence of required tools. Also third party inspection report would add weightage in process to get defects rectified from developer.',
      category: 'Professional'
    },
    { 
      question: 'Who must take home inspection services?', 
      answer: 'Home buyer who is about to take possession of new home, one who moving into recently renovated home, moving into rental home, buying a home in resale, building new home by own or appointed any builder/contractor.',
      category: 'Target'
    },
    { 
      question: 'What home inspection report includes?', 
      answer: 'Home inspection report includes detail description of defect points with relevant photo proofs. Severity category like low, medium and high risk for each defect point. Segregation of defect under various categories like Plumbing, Electrical, Carpentry, Civil, Painting, Housekeeping etc.',
      category: 'Report'
    },
    { 
      question: 'Is home Inspection application available?', 
      answer: 'SnagEasy Home Inspector app is used by inspectors to perform Home Inspection.',
      category: 'Technology'
    },
    { 
      question: 'When the report deliver to homebuyer?', 
      answer: 'Home inspection report PDF copy will be available in SnagEasy app within 24 hours after completion of onsite inspection. Same will be delivered on email as well.',
      category: 'Delivery'
    },
    { 
      question: 'Does the Developer Attend to All the Points Identified by the Third-Party Home Inspection?', 
      answer: 'Yes, developers generally address the defects highlighted in a third-party home inspection report—especially when the points are valid, documented, and fall under construction quality, safety, or RERA compliance. After receiving the report, the developer’s team reviews each observation, verifies it on-site, and carries out the required rectification within a reasonable timeframe. However, timelines and responses may vary based on the developer, severity of issues, and project policies. It is recommended that homeowners follow up with the developer and request a re-inspection after rectification to ensure all issues are properly resolved.',
      category: 'Developer'
    }
  ]
};
